import React, { useRef } from "react";
import { CSSTransition } from "react-transition-group";

const ModalWrapper = ({ show, onClose, children }) => {
  const nodeRef = useRef(null);

  return (
    <CSSTransition
      in={show}
      timeout={300}
      classNames="modal"
      unmountOnExit
      nodeRef={nodeRef}
    >
      <div className="modal" ref={nodeRef}>
        <div className="modal-content">
          <button className="close" onClick={onClose}>
            &times;
          </button>
          {children}
        </div>
      </div>
    </CSSTransition>
  );
};

export default ModalWrapper;
